import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import ManagedRenderComponent from '@aytm/lib/common/components/ManagedRenderComponent'

export default class Portal extends ManagedRenderComponent {
  static propTypes = {
    firstChild: PropTypes.bool,
    nodeStyle: PropTypes.object,
    nodeID: PropTypes.string
  }

  static updateOnProps = true

  constructor(props) {
    super(props)
    this.portalElement = document.createElement('div')
    if (props.nodeStyle) {
      for (const styleKey in props.nodeStyle) {
        this.portalElement.style[styleKey] = props.nodeStyle[styleKey]
      }
    }
    if (props.nodeID) {
      this.portalElement.id = props.nodeID
    }
  }

  componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount()
    }
    const { firstChild = false } = this.props
    if (firstChild) {
      document.body.insertBefore(this.portalElement, document.body.firstChild)
    } else {
      document.body.appendChild(this.portalElement)
    }
  }

  componentWillUnmount() {
    if (super.componentWillUnmount) {
      super.componentWillUnmount()
    }
    if (this.portalElement.parentNode == document.body) {
      document.body.removeChild(this.portalElement)
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.portalElement)
  }
}
